export default __webpack_public_path__ + "static/media/promptpay.49749236.jpg";